import React from 'react';
import {
  compose,
  pure,
  setDisplayName,
  branch,
  renderComponent,
  renderNothing
} from 'recompose';
import { StyledMultimedia } from './style';
import { Video, Gallery, Image } from './MultimediaType/index';

const checkTypeComponent = (media, type) => media === type;

const Multimedia = () => <StyledMultimedia />;

export default compose(
  setDisplayName('MultimediaView'),
  branch(
    ({ media }) => checkTypeComponent(media, 'IMAGE'),
    renderComponent(Image),
    branch(
      ({ media }) => checkTypeComponent(media, 'VIDEO'),
      renderComponent(Video),
      branch(
        ({ media }) => checkTypeComponent(media, 'GALLERY'),
        renderComponent(Gallery),
        renderNothing
      )
    )
  ),
  pure
)(Multimedia);
